import { render, staticRenderFns } from "./DefaultContainer.html?vue&type=template&id=2060005e&scoped=true&external"
import script from "./DefaultContainer.js?vue&type=script&lang=js&external"
export * from "./DefaultContainer.js?vue&type=script&lang=js&external"
import style0 from "./DefaultContainer.scss?vue&type=style&index=0&id=2060005e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2060005e",
  null
  
)

export default component.exports